

export class ShiftGroupTypeDto implements IShiftGroupTypeDto {
    id!: number | undefined;
    shiftGroupName!: string | undefined;
    isActive!: boolean;

    constructor(data?: IShiftGroupTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shiftGroupName = _data["shiftGroupName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ShiftGroupTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftGroupTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shiftGroupName"] = this.shiftGroupName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IShiftGroupTypeDto {
    id: number | undefined;
    shiftGroupName: string | undefined;
    isActive: boolean;
}

